import * as React from 'react';
import { observer } from 'mobx-react';
import strings from 'owa-strings/owa-options-strings';
import getStore from '../store/store';
import { OptionDescription } from 'owa-options-controls';
import { format } from 'owa-strings';
import { Link } from 'office-ui-fabric-react/lib/Link';
var styles = require('./ExportMailboxStatus.scss');
export default observer(function ExportMailboxStatus(props) {
    var _a = getStore(), isExportMailboxRequestMade = _a.isExportMailboxRequestMade, downloadLink = _a.downloadLink;
    return (isExportMailboxRequestMade && (React.createElement("div", { className: styles.statusDiv },
        React.createElement(OptionDescription, { className: styles.loadingStatus }, format(strings.option_export_mailbox_status_label, downloadLink
            ? strings.option_export_mailbox_export_complete
            : strings.option_export_mailbox_export_in_progress)),
        downloadLink && (React.createElement(Link, { href: downloadLink }, strings.option_export_mailbox_download_link)))));
});
//# sourceMappingURL=ExportMailboxStatus.js.map